module.exports = __webpack_public_path__ + "img/7bc49f2.png";